// extracted by mini-css-extract-plugin
export default {"wrapper":"toggleButton_wrapper__IB1F0","toggle":"toggleButton_toggle__HYF3A","label":"toggleButton_label__XCGOg"};